import { useMemo } from 'react'
import { i18nInstance, TranslatedText } from '@staccx/i18n'
import format from 'date-fns/format'

const SIGNING_NOTIFICATION_COLOR = '#E5EEFF'
const SIGNING_NOTIFICATION_FONT_COLOR = '#0D4BCC'

const CAR_NOTIFICATION_COLOR = '#FE9789'
const CAR_NOTIFICATION_FONT_COLOR = '#903209'

const CAR_NOTIFICATION_SECONDARY_COLOR = '#FFE4CC'
const CAR_NOTIFICATION_SECONDARY_FONT_COLOR = '#CB6201'

export const useNotifications = (pendingSignings, budgetSelections, fleetSummary) => {
  const carNotifications = useCarNotifications(fleetSummary)

  const notifications = useMemo(() => {
    const signingNotification = pendingSignings &&
      pendingSignings.length > 0 && {
        type: <TranslatedText i18nKey={'SIGNING_NOTIFICATION_TYPE'} />,
        title: `${pendingSignings.length} ${i18nInstance.translate('SIGNING_NOTIFICATION_TITLE')}`,
        message: `${i18nInstance.translate('DEADLINE')}: ${format(
          new Date(pendingSignings[0].createdAt).setMonth(new Date(pendingSignings[0].createdAt).getMonth() + 1),
          'dd.MM.yyyy',
        )}`,
        color: SIGNING_NOTIFICATION_COLOR,
        fontColor: SIGNING_NOTIFICATION_FONT_COLOR,
        path: '/tasks',
      }

    const budgetSelectionNotification = budgetSelections &&
      budgetSelections.length > 0 && {
        type: <TranslatedText i18nKey={'BUDGET_SELECTION_NOTIFICATION_TYPE'} />,
        title: <TranslatedText i18nKey={'BUDGET_SELECTION_NOTIFICATION_TITLE'} />,
        color: SIGNING_NOTIFICATION_COLOR,
        fontColor: SIGNING_NOTIFICATION_FONT_COLOR,
        path: '/tasks',
      }

    return [signingNotification, budgetSelectionNotification, ...carNotifications].filter(Boolean)
  }, [pendingSignings, budgetSelections, carNotifications])

  return notifications
}

const useCarNotifications = (fleetSummary) =>
  useMemo(() => {
    const carNotifications = []

    if (fleetSummary?.overMileageCount > 0) {
      carNotifications.push({
        type: <TranslatedText i18nKey={'MILEAGE_OVER_LIMIT'} />,
        title: (
          <TranslatedText i18nKey={'CARS_OVER_MILEAGE'}>
            {(value) => `${fleetSummary.overMileageCount} ${value}`}
          </TranslatedText>
        ),
        color: CAR_NOTIFICATION_COLOR,
        fontColor: CAR_NOTIFICATION_FONT_COLOR,
        path: '/cars?filter=overmileage',
      })
    }

    if (fleetSummary?.expiringCount > 0) {
      carNotifications.push({
        type: <TranslatedText i18nKey={'IS_OUTGOING'} />,
        title: <TranslatedText i18nKey={'CARS'}>{(value) => `${fleetSummary.expiringCount} ${value}`}</TranslatedText>,
        message: <TranslatedText i18nKey={'OUTGOING'} />,
        color: CAR_NOTIFICATION_SECONDARY_COLOR,
        fontColor: CAR_NOTIFICATION_SECONDARY_FONT_COLOR,
        path: '/cars?filter=expiring',
      })
    }

    if (fleetSummary?.unresolvedCount > 0) {
      carNotifications.push({
        type: <TranslatedText i18nKey={'UNCLARIFIED_CARS'} />,
        title: (
          <TranslatedText i18nKey={'CARS_UNCLARIFIED'}>
            {(value) => `${fleetSummary.unresolvedCount} ${value}`}
          </TranslatedText>
        ),
        message: <TranslatedText i18nKey={'ORDER_REORDER_RETURN'} />,
        color: CAR_NOTIFICATION_SECONDARY_COLOR,
        fontColor: CAR_NOTIFICATION_SECONDARY_FONT_COLOR,
        path: '/cars?filter=unresolved',
      })
    }

    return carNotifications
  }, [fleetSummary])
